export default __webpack_public_path__ + "static/media/icon-close.98ecf06b.svg";